// imports
import { useSelector, useDispatch } from 'react-redux';
import { Box, Link, Typography } from '@mui/material';

// local imports
import { RootState, uiActions } from '../../store';
import CustomDialog from '../../App/CustomDialog';
import dataOverviewArchitecture from '../../assets/images/data-overview-architecture.png';
import { STORAGE_KEY } from '../InfoDialogInitializer/InfoDialogInitializer';

// cloudfront prefix for links
const cloudfrontPrefix = import.meta.env.DEV ? `${import.meta.env.VITE_NWDC_S3_URL}` : import.meta.env.VITE_CLOUDFRONT_PROXY_PREFIX;

/**
 * Info
 *
 * Renders a modal with information about the application.
 *
 * @returns {JSX.Element} The rendered Info component.
 */
export default function InfoDialog() {
  const { infoDialogOpen } = useSelector((state: RootState) => state.ui);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(uiActions.toggleInfoDialog());
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  };

  return (
    <CustomDialog
      open={infoDialogOpen}
      onClose={handleClose}
      title="NWDC Interactive Map"
      dataTestId="info-dialog"
    >
      <Typography component="span" variant="body1">
        The National Water Availability Assessment Data Companion (NWDC) is a centralized website providing U.S. Geological Survey (USGS) model-derived water availability, supply, and use data. This interactive map allows users to explore these data.  <br /><br /> Data are organized according to the following structure: any sector may contain multiple models, and any model may have multiple variables. For a full list of models and variables currently available, visit the <Link target="_blank"
          rel="noopener noreferrer"
          href={`${cloudfrontPrefix}/data-catalog/`}
        >Data Catalog</Link>.
      </Typography>
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <img
          src={dataOverviewArchitecture}
          alt="Diagram showing the data overview architecture: sectors contain models, and models contain variables"
          style={{ maxWidth: '80%' }}
        />
      </Box>
    </CustomDialog>
  );
}